import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import {
    Checkbox, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, TableSortLabel, TablePagination, TableFooter
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import Info from '@mui/icons-material/Info';
import AddIcon from '@mui/icons-material/Add';
import CopyrightIcon from '@mui/icons-material/Copyright';
import RefreshIcon from '@mui/icons-material/Refresh';
import ApiIcon from '@mui/icons-material/Api';
import { Tooltip } from '@mui/material';
import { useLocation, Link } from 'react-router-dom';
import Modal from '@mui/material/Modal';
import { Box } from '@mui/material';
// import SalePrint from './Print';
import PrintIcon from '@mui/icons-material/Print';
import ReactDOM from 'react-dom';

function PaymentAndReceiptIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const history = useHistory(); // Access the navigation history
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [isFocused, setIsFocused] = useState(false);

    const { isAuthenticated, companyId, branchId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Accounts');
    const hasEditMasterPermission = permissions.includes('Edit Accounts');
    const hasDeleteMasterPermission = permissions.includes('Delete Accounts');
    const [open, setOpen] = useState(false);
    const [requestedItemdata, setrequestedItemdata] = useState([]);
    const [purchaseRequestdatacount, setpurchaseRequestdatacount] = useState('');
    const location = useLocation();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const shouldReload = localStorage.getItem('shouldReload') === 'true';

        // Only reload data if navigated from PurchaseOrderCreate and flag is set
        if (location.state?.from === '/PaymentAndReceiptCreate' && shouldReload) {
            localStorage.removeItem('shouldReload'); // Clear the flag after use
            window.location.reload();
        }
        else if (location.state?.from === '/PaymentAndReceiptEdit' && shouldReload) {
            localStorage.removeItem('shouldReload'); // Clear the flag after use
            window.location.reload();
        }
        else if (location.state?.from === '/PaymentAndReceiptDetails' && shouldReload) {
            localStorage.removeItem('shouldReload'); // Clear the flag after use
            window.location.reload();
        }
        else {
            // Populate data without reloading for other cases
            setFromDate(getFormattedStartDate());
            setToDate(getFormattedCurrentDate());
        }
    }, [location]);

    const handleClose = () => {
        setOpen(false);
    };

    // Define the modal style
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        bgcolor: 'white',
        boxShadow: 24,
        borderRadius: '10px'
    };


    useEffect(() => {
        // Check if reload is needed based on the flag set in localStorage
        const shouldReload = localStorage.getItem('shouldReloadCreatePage') === 'true';

        if (shouldReload) {
            localStorage.removeItem('shouldReloadCreatePage'); // Remove the flag after use
            window.location.reload(); // Reload the page once
        }

        // Authentication and token expiration handling
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        // Other initializations, if any
    }, [isAuthenticated, token, logout]);



    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };


    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };


    const fetchTableData = async () => {
        setLoading(true);
        setData([]);
        try {
            const response = await fetchData('PaymentAndReceiptApi', `/${companyId}/${branchId}/${fromDate}/${toDate}`, token);
            if (response.responseCode === '1111') {
                setData(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching SaleOrder Details:', error);
            if (error.response && error.response.status === 401) {
                logout();
                history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
            }
        } finally {
            setLoading(false);
        }

    };


    const handleDelete = async () => {
        deleteData('PaymentAndReceiptApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchTableData();
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('PaymentAndReceiptApi', `${itemId}`, token)
            .then(() => {
                fetchTableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    function formatDate(dateString) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
        return formattedDate;
    }

    const commonButtonStyles = {
        height: '36px',
        marginLeft: '10px',
        marginTop: '10px',
        marginRight: '8px',
    };

    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState('PurchaseOrderDate');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const sortedData = stableSort(filteredData, getComparator(order, orderBy));




    return (
        <div className="w-full  mx-auto" style={{ width: '100%', marginTop: '10px' }}>
            <div className='w-full mb-2 flex'>
                <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}> Payment & Receipt</h6>
                {loading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}>
                        <div>
                            <CircularProgress style={{ color: 'white' }} />
                            <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                        </div>
                    </div>
                )}

                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'left', marginTop: '17px' }}>
                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '270px' : '200px',
                            height: '40px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            padding: '0 20px',
                            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                            outline: 'none',
                            borderColor: isFocused ? 'darkcyan' : '#ccc',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                        }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        From
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        To
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>

                <Tooltip
                    title="Get Payment & Receipt Details" arrow>
                    <Button
                        style={{
                            backgroundColor: 'white',
                            borderRadius: '20px',
                            padding: '5px 10px',
                            border: '1px solid blue',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '30px',
                            marginLeft: '15px',
                            marginTop: '1.50%',
                            textTransform: 'uppercase'

                        }}
                        onClick={fetchTableData}
                        className="linkcolor"
                    >
                        <span>Refresh</span>
                    </Button>
                </Tooltip>

                {hasCreateMasterPermission && (
                    <Tooltip
                        title="Create New Payment & Receipt" arrow>
                        <Button
                            style={{
                                backgroundColor: 'white',
                                borderRadius: '20px',
                                padding: '5px 10px',
                                border: '1px solid black',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                maxHeight: '30px',
                                marginLeft: '15px',
                                marginTop: '1.50%',
                                textTransform: 'uppercase'

                            }}
                            component={Link}
                            to="/PaymentAndReceiptCreate"
                            className="linkcolor"
                        >
                            <span>Create</span>
                        </Button>
                    </Tooltip>
                )}
            </div>

            <div className="watermark">
                <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
            </div>

            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto', marginTop: '-1%' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#243642', width: '2500px' }}>
                            <TableCell className='table-header-cell'>Sl.No</TableCell>
                            <TableCell className='table-header-cell'>BILL DATE</TableCell>
                            <TableCell className='table-header-cell'>BILL NO</TableCell>
                            <TableCell className='table-header-cell'>NAME</TableCell>
                            <TableCell className='table-header-cell'>Remarks</TableCell>
                            <TableCell className='table-header-cell' style={{ textAlign: 'right' }}>Amount</TableCell>
                            <TableCell className='table-header-cell' style={{ textAlign: 'right' }}></TableCell>
                        </TableHead>

                        <TableBody style={{ backgroundColor: '#F5F7F8' }}>
                            {sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((data, index) => (
                                <TableRow
                                    key={data.id}
                                    className={'highlighted-row'}
                                    sx={{
                                        '&:hover': {
                                            backgroundColor: '#E3FEF7',
                                        },
                                    }}
                                >
                                    <TableCell className='table-header-cell.child' style={{ padding: '3px' }}>
                                        {index + 1}
                                    </TableCell>
                                    <TableCell className='table-header-cell.child' style={{ padding: '3px' }}>
                                        {formatDate(data.BillDate)}
                                    </TableCell>
                                    <TableCell className='table-header-cell.child' style={{ padding: '3px' }}>
                                        {data.BillNumber}/{data.FinYear}
                                    </TableCell>
                                    <TableCell className='table-header-cell.child' style={{ padding: '3px' }}>
                                        {data.MasterName}
                                    </TableCell>
                                    <TableCell className='table-header-cell.child'
                                        sx={{
                                            borderBottom: '1px solid #D4E2D4',
                                            color: data.Remarks === 'Remarks' ? 'red' : 'green',
                                            padding: '3px',
                                            textAlign: 'left',
                                            fontSize: '14px',
                                            fontWeight: 'bold',
                                            width: '15%',
                                        }}
                                    >
                                        {data.Remarks}
                                    </TableCell>

                                    <TableCell className='table-header-cell.child' style={{ padding: '3px', textAlign: 'right' }}>
                                        {data.Amount ? data.Amount.toFixed(2) : "0.00"}
                                    </TableCell>

                                    <TableCell className='table-header-cell.child' style={{ padding: '3px', textAlign: 'right' }}>
                                        <Tooltip
                                            title="Payment & Receipt Details" arrow>
                                            <IconButton component={Link} to={`/PaymentAndReceiptDetails/${data.Id}`}>
                                                <Info style={{ color: 'coral', height: '22px' }} />
                                            </IconButton>
                                        </Tooltip>
                                        {hasEditMasterPermission && (
                                            <Tooltip
                                                title="Edit Payment & Receipt" arrow>
                                                <IconButton component={Link} to={`/PaymentAndReceiptEdit/${data.Id}`} >
                                                    <EditIcon style={{ height: '22px', color: 'darkblue' }} />
                                                </IconButton>
                                            </Tooltip>
                                        )}

                                        {hasDeleteMasterPermission && (
                                            <Tooltip
                                                title={data.IsActive ? "Payment Delete" : "Payment Activate"} arrow>
                                                <IconButton onClick={() => (data.IsActive ? openConfirmDialog(data.Id) : handleActivate(data.Id))} color="error">
                                                    {data.IsActive ? <DeleteSweepIcon style={{ height: '22px', color: 'darkred' }} /> : <ActivateIcon style={{ color: 'darkolivegreen', height: '22px' }} />}
                                                </IconButton>
                                            </Tooltip>
                                        )}

                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>

                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>

                        </Dialog>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={filteredData.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </TableContainer>
            </div>
        </div >

    );
}


function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

export default PaymentAndReceiptIndex;

